"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _configProvider = require("../config-provider/configProvider");
var _icon = require("../icon");
var _utils = require("../utils");
var _classnames2 = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ICON_TYPE = {
  success: 'success-circle',
  info: 'info-circle',
  warning: 'warning-circle',
  error: 'error-circle'
};
var MessageContent = function MessageContent(_ref) {
  var type = _ref.type,
    icon = _ref.icon,
    closable = _ref.closable,
    colorful = _ref.colorful,
    children = _ref.children,
    remainingTime = _ref.remainingTime,
    onClose = _ref.onClose;
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls('message');
  var iconType = ICON_TYPE[type];
  var iconNode = null;
  if (type === 'loading') {
    iconNode = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      type: "load",
      className: "".concat(prefixCls, "-icon-loading")
    });
  } else if ((0, _utils.isString)(icon)) {
    iconNode = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      type: icon
    });
  } else if ( /*#__PURE__*/_react.default.isValidElement(icon)) {
    iconNode = icon;
  } else if (iconType) {
    iconNode = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      type: iconType
    });
  }
  var cls = (0, _classnames2.default)("".concat(prefixCls, "-content").concat(type ? " ".concat(prefixCls, "-").concat(type) : ''), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-content-closble"), closable), "".concat(colorful ? "".concat(prefixCls, "-content-theme-").concat(type) : ''));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cls
  }, iconNode && /*#__PURE__*/_react.default.cloneElement(iconNode, {
    className: (0, _classnames2.default)("".concat(prefixCls, "-icon"), iconNode.props.className)
  }), /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.isFunction)(children) ? children(remainingTime) : children), closable ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: "".concat(prefixCls, "-close"),
    type: "close-thick",
    onClick: onClose
  }) : null);
};
MessageContent.displayName = 'MessageContent';
var _default = exports.default = MessageContent;